import template from './opportunityProductFinder.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    opportunityCalculationService: '<',
  },
};
